import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  kpiCode: Yup.string()
    .required("KPI Code is required")
    .max(20, "Maximum 20 characters allowed"),

  kpiType: Yup.string().required("KPI Type is required"),

  isActive: Yup.boolean().required("Status is required"),
});

const AddEditIEKpiTypeForm = ({
  isOpen,
  onClose,
  onSubmit,
  initialData = null,
  isEdit = false,
}) => {
  if (!isOpen) return null;

  const initialValues = {
    kpiCode: initialData?.kpiCode || "",
    kpiType: initialData?.kpiType || "",
    isActive: initialData?.isActive !== undefined ? initialData.isActive : true,
  };

  return (
    <>
      <div
        className="modal fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: "8px" }}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              enableReinitialize
              onSubmit={(values, { setSubmitting }) => {
                onSubmit(values);
                setSubmitting(false);
              }}
            >
              {({ values, setFieldValue, isSubmitting }) => (
                <Form>
                  <div className="modal-header border-0 p-6">
                    <h4 className="modal-title fw-semibold">
                      {isEdit ? "Edit KPI Type" : "Add KPI Type"}
                    </h4>

                    <button
                      type="button"
                      className="btn-close"
                      onClick={onClose}
                    />
                  </div>

                  <div className="modal-body">
                    <hr className="mt-0" />

                    <div className="container-fluid px-4">
                      {/* KPI Code */}
                      <div className="row mb-4">
                        <div className="col-12">
                          <label className="form-label mb-2 align-items-left d-flex gap-1">
                            KPI Code <span className="text-danger">*</span>
                          </label>

                          <Field
                            type="text"
                            name="kpiCode"
                            className="form-control"
                            placeholder="Enter KPI Code"
                          />

                          <ErrorMessage
                            name="kpiCode"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      {/* KPI Type */}
                      <div className="row mb-4">
                        <div className="col-12">
                          <label className="form-label mb-2 align-items-left d-flex gap-1">
                            KPI Type <span className="text-danger">*</span>
                          </label>

                          <Field
                            type="text"
                            name="kpiType"
                            className="form-control"
                            placeholder="Enter KPI Type"
                          />

                          <ErrorMessage
                            name="kpiType"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </div>

                      {/* Status */}
                      <div className="row mb-3">
                        <div className="col-12">
                          <label className="form-label mb-3 align-items-left d-flex gap-1">
                            Status <span className="text-danger">*</span>
                          </label>

                          <div className="d-flex align-items-center gap-5">
                            <div className="form-check">
                              <input
                                type="radio"
                                id="active"
                                name="status"
                                className="form-check-input"
                                checked={values.isActive === true}
                                onChange={() => setFieldValue("isActive", true)}
                              />
                              <label
                                htmlFor="active"
                                className="form-check-label"
                              >
                                Active
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                type="radio"
                                id="inactive"
                                name="status"
                                className="form-check-input"
                                checked={values.isActive === false}
                                onChange={() =>
                                  setFieldValue("isActive", false)
                                }
                              />
                              <label
                                htmlFor="inactive"
                                className="form-check-label"
                              >
                                Inactive
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-primary px-4"
                      onClick={onClose}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="btn btn-primary px-4"
                      disabled={isSubmitting}
                    >
                      {isEdit ? "Update" : "Save"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default AddEditIEKpiTypeForm;
